<div class="card log-usuario-container">
    <div class="flex align-items-center justify-content-between mb-3 log-usuario-header">
        <div>
            <h5 class="p-m-0">Log de Ações de Usuário</h5>
            <small class="p-text-secondary">Visualize os logs de ações realizadas pelos usuários no sistema.</small>
        </div>
    </div>

    <!-- Filtros -->
    <div class="p-card mb-3">
        <div class="p-card-body">
            <div class="p-fluid grid">
                <div class="field field-label-top col-12 md:col-3">
                    <label for="usuario">Usuário</label>
                    <p-dropdown inputId="usuario" appendTo="body" [options]="dropDownUsuarios"
                        [(ngModel)]="usuarioSelecionado" [filter]="true"
                        filterPlaceholder="Pesquisar usuário" [showClear]="true" placeholder="Selecione">
                    </p-dropdown>
                </div>

                <div class="field field-label-top col-12 md:col-3">
                    <label for="tabela_alterada">Tabela Alterada</label>
                    <p-dropdown inputId="tabela_alterada" appendTo="body" [options]="dropDownTabelas"
                        [(ngModel)]="tabelaAlterada" [filter]="true"
                        filterPlaceholder="Pesquisar tabela" [showClear]="true" placeholder="Selecione">
                    </p-dropdown>
                </div>

                <div class="field field-label-top col-12 md:col-2">
                    <label for="data_inicial">Data Inicial</label>
                    <p-datepicker inputId="data_inicial" [(ngModel)]="dataInicial"
                        dateFormat="dd/mm/yy" [showIcon]="true"
                        [maxDate]="dataFinal" placeholder="Data Inicial" styleClass="w-full">
                    </p-datepicker>
                </div>

                <div class="field field-label-top col-12 md:col-2">
                    <label for="data_final">Data Final</label>
                    <p-datepicker inputId="data_final" [(ngModel)]="dataFinal"
                        dateFormat="dd/mm/yy" [showIcon]="true"
                        [minDate]="dataInicial" placeholder="Data Final" styleClass="w-full">
                    </p-datepicker>
                </div>

                <div class="field col-12 md:col-2 flex align-items-end">
                    <button pButton pRipple type="button" label="Filtrar" icon="pi pi-search"
                        class="p-button-primary" (click)="filtrar()" [loading]="loading">
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Grid -->
    <div class="log-usuario-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="perPage" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id" [loading]="loading"
            [lazy]="true" (onLazyLoad)="onPageChange($event)"
            [totalRecords]="totalRecords" [first]="first"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [scrollable]="true" [scrollHeight]="scrollHeight">

        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between p-flex-wrap">
                <div class="flex align-items-center p-flex-wrap">
                    <h5 class="p-m-0" style="margin-right: 30px;">Logs de Usuário</h5>
                </div>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>Data/Hora</th>
                <th>Usuário</th>
                <th>Email</th>
                <th>Tabela Alterada</th>
                <th>Registro Alterado</th>
                <th>Descrição</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr>
                <td>
                    <span class="p-column-title negrito">Data/Hora: </span>
                    {{formatarDataHora(item.data_hora)}}
                </td>
                <td>
                    <span class="p-column-title negrito">Usuário: </span>
                    {{getNomeUsuario(item)}}
                </td>
                <td>
                    <span class="p-column-title negrito">Email: </span>
                    {{getEmailUsuario(item)}}
                </td>
                <td>
                    <span class="p-column-title negrito">Tabela Alterada: </span>
                    {{item.tabela_alterada || 'N/A'}}
                </td>
                <td>
                    <span class="p-column-title negrito">Registro Alterado: </span>
                    {{item.registro_alterado || '-'}}
                </td>
                <td>
                    <span class="p-column-title negrito">Descrição: </span>
                    {{item.descricao || 'N/A'}}
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" style="text-align: center;">
                    Nenhum log encontrado. Aplique os filtros para buscar logs.
                </td>
            </tr>
        </ng-template>
        </p-table>
    </div>
</div>

<p-toast></p-toast>

